module.exports = __webpack_public_path__ + "static/media/icon-dropbox.6b3e5565.jpg";